var GuidanceFilters = (function () {

    var buttonFilter;
// quick search regex
    var qsRegex;

    var _opts = {
        $grid: null,
        selectors: {
            selects: '.guidance-select',
            search:  '.guidance-input',
            grid: '.filter-listing-container',
            item: '.filter-row',
            message: '.filter-message',
            filter_count: '.filter-count',
            actual_count: '#actual_count',
            actual_location: '.actual_location',
            actual_term: '.actual_term',
            parent_category: '.guidance-select#parent_category',
            child_category:  '.guidance-select#child_category',
            reset_all: '.reset-guidance-filters',
        },
        filters: {
            parent: false
        }
    };

    var fallbackSelectParents = [];
    var fallbackSelectChildren = [];

    var full_count = 0;
    var current_actual_parent_text = '';
    var current_actual_child_text = '';
    var current_actual_term = '';

    var parent_categories_preserved = [];
    var parent_group_preserved;

    var most_recent_keystroke = false;


    var _debounce = function(n,t){var e;return t=t||200,function(){clearTimeout(e);var u=arguments,i=this;e=setTimeout(function(){n.apply(i,u)},t)}};


    var _updateResults = function () 
    {
        _opts.$grid.isotope();

        // get some variables for the results messages
        var item_count = $(_opts.selectors.grid).data('isotope').filteredItems.length;
        current_actual_child_text = $(_opts.selectors.child_category + " option:selected").text();
        current_actual_parent_text = $(_opts.selectors.parent_category + " option:selected").text();
        current_actual_term = $(_opts.selectors.search).val();
        parent_val = $( _opts.selectors.parent_category ).val();
        var parent_val_id = $( _opts.selectors.parent_category  + " option:selected" ).data('term-id');
        child_val = $( _opts.selectors.child_category ).val();

        // END get some variables

        // Change the available items in child, based on current terms
        // if the user changes the child, then we need to rebuild the child
        //console.log (parent_val + "/" + parent_group_preserved + "//" + $(_opts.selectors.grid).data('isotope').filteredItems.length);

        if (parent_val != parent_group_preserved)
        {
            parent_categories_preserved = [];
            parent_group_preserved = parent_val;    
            for (var i = 0; i < $(_opts.selectors.grid).data('isotope').filteredItems.length; i++)
            {
                var these_tags = $(_opts.selectors.grid).data('isotope').filteredItems[i]['element']['className'];

                if (these_tags && these_tags.length > 1 && these_tags !== undefined )
                {
                    these_tags_array = these_tags.split(" ");
                    if (Array.isArray(these_tags_array))
                    {
                        for (var j = 0; j < these_tags_array.length; j++)
                        {
                            var this_tag = "." + these_tags_array[j];
                            if (parent_categories_preserved.indexOf(this_tag) < 0)
                            {
                                parent_categories_preserved.push(this_tag);
                            }
                        }
                    }
                }
            }

        }

        // if parent is not set, or there is no results, or no search term, remove the preserved variables
        if (parent_val == "*" || item_count == 0)
        {
            parent_categories_preserved = [];
            parent_group_preserved = parent_val;
        }
         
        // if there are current child terms, disable child options that do not match   
        // this is done through a CSS class so as not to conflict with isotope's "style display"
        if (parent_categories_preserved.length > 0)
        {
            var newChildren = "\n" + '<option value="*" selected="" class="guidance-select__placeholder">Select a Guidance Category</option>';

            var holdChild = $(_opts.selectors.child_category).val();

            fallbackSelectChildren.forEach(function (arrayItem) {
                var test = (arrayItem.val);
                if (test && test != "" && current_actual_parent_text !== undefined)
                {
                    if (parent_categories_preserved.indexOf(test) > -1 && arrayItem.parent_term_id == parent_val_id)
                    {

                        var newLine = "\n" + '<option value="' + arrayItem.val + '"';
                        if (arrayItem.classname && arrayItem.classname !== undefined)
                        {
                            newLine += ' class="' + arrayItem.classname  + '"';
                        }
                        if (arrayItem.parent_term_id && arrayItem.parent_term_id !== undefined)
                        {
                            newLine += ' data-parent-term-id="' + arrayItem.parent_term_id  + '"';
                        }

                        if (holdChild && holdChild !== undefined && holdChild == arrayItem.val)
                        {
                            newLine += ' selected="selected"';
                        }

                        newLine += ">" + arrayItem.text;
                        newLine += '</option>';

                        newChildren += newLine;
                    }
                }
            });

            $(_opts.selectors.child_category).html(newChildren);


            /*
            // replaced show/hide in favour of JS swapping
            $(_opts.selectors.child_category + " > option").each(function() 
            {
                var this_val = $(this).val();
                var this_term_id = $(this).data('parent-term-id');
                if (parent_categories_preserved.indexOf(this_val) < 0 && this_term_id != parent_group_preserved)
                {
                    $(this).addClass("no-show-option"); 
                }
                else
                {
                    $(this).removeClass("no-show-option");   
                }
            });*/
        }
        // else clear disabled from all child fields, but return the select to disabled
        else
        {   

            if (item_count == 0)
            {
                var newChildren = "\n" + '<option value="*" selected="" class="guidance-select__placeholder" disabled="disabled">Select a Guidance Category</option>';
                $(_opts.selectors.child_category).html(newChildren);
            }
            else
            {
                var newChildren = "";
                fallbackSelectChildren.forEach(function (arrayItem) {
                    var newLine = "\n" + '<option value="' + arrayItem.val + '"';
                    if (arrayItem.classname && arrayItem.classname !== undefined)
                    {
                        newLine += ' class="' + arrayItem.classname  + '"';
                    }
                    if (arrayItem.parent_term_id && arrayItem.parent_term_id !== undefined)
                    {
                        newLine += ' data-parent-term-id="' + arrayItem.parent_term_id  + '"';
                    }
                    newLine += ">" + arrayItem.text;
                    newLine += '</option>';

                    newChildren += newLine;
                });

                $(_opts.selectors.child_category).html(newChildren);

                // replaced show/hide in favour of JS swapping
                /*$(_opts.selectors.child_category + " > option").each(function() 
                {
                    $(this).removeClass("no-show-option");    
                });*/
            }
        }
        // END change the available items in child, based on current terms

        // change the results message(s)
        var new_message = "";
        if (parent_val != "*" && parent_val != "" && current_actual_parent_text != "Select a Guidance Area" && current_actual_parent_text && current_actual_parent_text != '' && current_actual_parent_text !== undefined )
        {
            if (child_val != "*" && child_val != "" && current_actual_child_text != "Select a Guidance Category" && current_actual_child_text && current_actual_child_text != '' && current_actual_child_text !== undefined )
            {
                var new_message = " in " + current_actual_parent_text + " " + current_actual_child_text;
            }
            else
            {
                var new_message = " in " + current_actual_parent_text;
            }
        }
        
        $(_opts.selectors.actual_location).html( new_message );

        $(_opts.selectors.actual_term).html( "<b>" + current_actual_term + "</b>" );

        if ( item_count < 1 ) 
        {
            $(_opts.selectors.filter_count).addClass('hide');
            $(_opts.selectors.message).removeClass('hide');
        } 
        else 
        {
            $(_opts.selectors.filter_count).removeClass('hide');
            $(_opts.selectors.message).addClass('hide');
        }

        $(_opts.selectors.actual_count).text( item_count );

        most_recent_keystroke = current_actual_term;

        // wait 3 seconds. if this term still matches the saved term, then add to analytics
        setTimeout(function()
        {
           if (current_actual_term.length > 3 && most_recent_keystroke == current_actual_term)
           {
                ga('send', 'event', 'Guidance Search', 'text-input', current_actual_term);
           }
        }, 3000);

        // END change the results message(s)

    };

    var _updateSelects = function () 
    {
        if( _opts.filters.parent ) 
        {

            $( _opts.selectors.child_category ).attr('disabled', false );
            $( _opts.selectors.child_category ).find('option:not(.guidance-select__placeholder)').hide();
            $( _opts.selectors.child_category ).find('[data-parent-term-id="' + _opts.filters.parent + '"]').show();
        }
    };

    var _updateCriteria = function ( e ) 
    {
        var option = $(this).find(':selected').last();
        var isParent =  option.data('term-id') !== undefined;
        var isReset = option.data('term-reset') !== undefined;

        //console.log(option);

        buttonFilter = '';

        if(isParent) {
            _opts.filters.parent = option.data('term-id');
            $(_opts.selectors.child_category).prop('selectedIndex',0);
        }
        if(isReset) {
            _opts.filters.parent = null;
            $(_opts.selectors.child_category).prop('selectedIndex',0);
            _opts.filters.child = false;
            $( _opts.selectors.child_category ).attr('disabled', true );  
            $( _opts.selectors.child_category ).find('option:not(.guidance-select__placeholder)').show();
            $( _opts.selectors.child_category ).find('[data-parent-term-id="' + _opts.filters.parent + '"]').hide();
        }

        $( _opts.selectors.selects ).each(function () {
            if( $(this).val() !== null && $(this).val() !== '*' ) {
                buttonFilter += $(this).val();
            }
        });

        if( buttonFilter === '' ) buttonFilter = '*';
        _updateSelects();
        _updateResults();

    };

    var _initIsotope = function () {
        _opts.$grid = $(_opts.selectors.grid).isotope(
        {
            // layoutMode: 'vertical',
            itemSelector: _opts.selectors.item,
            filter: function() {
                var $this = $(this);
                var searchResult = qsRegex ? $this.text().match( qsRegex ) : true;
                var buttonResult = buttonFilter ? $this.is( buttonFilter ) : true;
                return searchResult && buttonResult;
            },
        });
    };

    var _initFallBackSelects = function () {

        $(_opts.selectors.parent_category + " > option").each(function() 
        {
            var this_val = $(this).val();
            var this_text = $(this).html();
            var this_term_id = $(this).data('term-id');
            var this_term_reset = $(this).data('term-reset');
            fallbackSelectParents.push(
                {
                    val: this_val,
                    text: this_text,
                    parent_id:  this_term_id,
                    term_reset: this_term_reset
                }
            );

        })

        $(_opts.selectors.child_category + " > option").each(function() 
        {
            var this_val = $(this).val();
            var this_text = $(this).html();
            var this_parent_term_id = $(this).data('parent-term-id');
            var this_classname = $(this).attr("class");
            fallbackSelectChildren.push(
                {
                    val: this_val,
                    text: this_text,
                    parent_term_id:  this_parent_term_id,
                    classname: this_classname
                }
            );

        });
    };

    var _addEvents = function () 
    {

        _initFallBackSelects();

        _initIsotope();

        $( _opts.selectors.actual_count).text( $( _opts.selectors.item ).length );

        $( _opts.selectors.selects ).change(_updateCriteria);

        $( _opts.selectors.item ).find('[data-toggle]').click(function () {

           setTimeout(function(){
               _opts.$grid.isotope('layout');
           }, 250);
        });

        // use value of search field to filter
        var $quicksearch = $(_opts.selectors.search).keyup( _debounce( function() 
        {
            var use_string = $quicksearch.val();
            /*if ($quicksearch.val().length < 3)
            {
                use_string = '';
            }*/
            qsRegex = new RegExp(use_string, 'gi' );

            _updateResults();
        }));

    };

    $( '.reset-guidance-filters' ).click(function(e)
    {
        e.preventDefault();
        
        // clear the data on the form
        $(".guidance-select#parent_category").val("*");
        $(".guidance-select#child_category").val("*");
        $(".guidance-input").val("");
        // clear stored vars
        qsRegex = '';
        
        andthen();
    });


    function andthen()
    {
        _updateCriteria();
    }


    var init = function () {
        if( $(_opts.selectors.selects ).length || $(_opts.selectors.search ).length ) _addEvents();
    };

    return {
        init: init
    }

})();

$( document ).ready( function()
{
    $(".guidance-select#parent_category").val("*");
    $(".guidance-select#child_category").val("*");
    $(".guidance-input").val("");
    GuidanceFilters.init();
});
